"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _forOwn = _interopRequireDefault(require("lodash/forOwn"));
var _isString = _interopRequireDefault(require("lodash/isString"));
var _phoneNumberPattern = _interopRequireDefault(require("../enums/phone-number-pattern"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function isPhoneNumber(phoneNumber) {
  var isPhone = false;
  if ((0, _isString.default)(phoneNumber)) {
    var ausNumber = phoneNumber.trim().replace(/\s/g, '');
    ausNumber = ausNumber.replace('+6113', '13');
    ausNumber = ausNumber.replace('+6118', '18');
    ausNumber = ausNumber.replace('+61', '0');
    (0, _forOwn.default)(_phoneNumberPattern.default, pattern => {
      if (ausNumber.match(pattern) !== null) {
        isPhone = Boolean(ausNumber.match(pattern));
      }
    });
  }
  return isPhone;
}
var _default = exports.default = isPhoneNumber;